var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6667 9.54529L26.0607 18.9393C26.6465 19.5251 26.6465 20.4748 26.0607 21.0606L16.6667 30.4546L14.5454 28.3333L22.8787 19.9999L14.5454 11.6666L16.6667 9.54529Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 18.5H25C25.8284 18.5 26.5 19.1716 26.5 20C26.5 20.8284 25.8284 21.5 25 21.5H3.5V18.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 3.5H31.6667C32.9485 3.5 34.1779 4.00922 35.0843 4.91565C35.9908 5.82208 36.5 7.05145 36.5 8.33333V31.6667C36.5 32.9485 35.9908 34.1779 35.0843 35.0843C34.1779 35.9908 32.9485 36.5 31.6667 36.5H23.5V33.5H31.6667C32.1529 33.5 32.6192 33.3068 32.963 32.963C33.3068 32.6192 33.5 32.1529 33.5 31.6667V8.33333C33.5 7.8471 33.3068 7.38079 32.963 7.03697C32.6192 6.69315 32.1529 6.5 31.6667 6.5H23.5V3.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.70879d37.svg";
export { ForwardRef as ReactComponent };